import { transformCollectionItemDtosToProductItems } from './product-item';
export const transformCollection = dto => ({
  discount: dto.discount,
  id: dto.id,
  isActive: dto.is_active,
  title: dto.title,
  items: transformCollectionItemDtosToProductItems(dto.items)
});